import { useNavigate, useParams } from "react-router";
import { ChapterEditor } from "../components/editors/ChapterEditor";

export function ChapterPage() {
  const { storyId = "", chapterId = "" } = useParams();
  const navigate = useNavigate();
  return (
    <ChapterEditor
      storyId={storyId}
      chapterId={chapterId}
      onDeleted={() => navigate(`/stories/${storyId}`, { replace: true })}
    />
  );
}
